"use client";

import { c as _c } from "react/compiler-runtime";
import { ShopItemDescription } from "../components/shop-item-description";
import { ShopItemGallery, shopItemImages } from "../components/shop-item-gallery";
import { type CatalogOfferAction, getCatalogPromotionDetails } from "../promotion-messaging";
import React, { useRef, useState } from "react";
import { FiCheckCircle, FiImage, FiMapPin, FiPlus, FiTag } from "react-icons/fi";
import Button from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle } from "@/components/ui/dialog";
import QuantityStepper from "@/components/ui/quantity-stepper";
import { formatCurrency } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import { type RegularCatalogShopItem, type ShopCartLine, type ShopItem } from "@/types/shop";
interface PromotionQuickAddRowProps {
  action: CatalogOfferAction;
  cartQuantity: number;
  onQuickAdd: (itemId: string, quantity: number) => void;
}
const PromotionQuickAddRow: React.FC<PromotionQuickAddRowProps> = t0 => {
  const $ = _c(31);
  const {
    action,
    cartQuantity,
    onQuickAdd
  } = t0;
  const [quantity, setQuantity] = useState(action.quantity);
  const [justMet, setJustMet] = useState(false);
  const requirementMet = cartQuantity >= action.quantity || justMet;
  let t1;
  if ($[0] !== action.itemId || $[1] !== action.quantity || $[2] !== cartQuantity || $[3] !== onQuickAdd || $[4] !== quantity) {
    t1 = () => {
      onQuickAdd(action.itemId, quantity);
      if (cartQuantity + quantity >= action.quantity) {
        setJustMet(true);
      }
    };
    $[0] = action.itemId;
    $[1] = action.quantity;
    $[2] = cartQuantity;
    $[3] = onQuickAdd;
    $[4] = quantity;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleQuickAdd = t1;
  const t2 = requirementMet ? "border-status-success-text/30 bg-status-success-bg" : "border-border bg-background";
  let t3;
  if ($[6] !== t2) {
    t3 = cx("flex flex-wrap items-center gap-3 rounded-xl border p-2 transition-colors duration-300", t2);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== action.itemImage) {
    t4 = action.itemImage ? <img src={action.itemImage} alt="" loading="lazy" className="h-12 w-12 flex-none rounded-lg bg-muted object-cover" /> : <span className="flex h-12 w-12 flex-none items-center justify-center rounded-lg bg-muted text-foreground-muted"><FiImage aria-hidden={true} /><span className="sr-only">No item image</span></span>;
    $[8] = action.itemImage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== action.itemName) {
    t5 = <p className="truncate text-body-emphasis text-foreground">{action.itemName}</p>;
    $[10] = action.itemName;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== action.itemDescription) {
    t6 = action.itemDescription && <p className="mt-0.5 line-clamp-2 text-caption leading-relaxed text-foreground-secondary">{action.itemDescription}</p>;
    $[12] = action.itemDescription;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== action.itemPrice) {
    t7 = formatCurrency(action.itemPrice);
    $[14] = action.itemPrice;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <p className="mt-1 text-caption font-semibold text-foreground">{t7} each</p>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t8) {
    t9 = <div className="min-w-32 flex-1">{t5}{t6}{t8}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== handleQuickAdd || $[23] !== quantity || $[24] !== requirementMet) {
    t10 = requirementMet ? <span role="status" className="flex animate-in items-center gap-2 whitespace-nowrap px-2 text-caption font-semibold text-status-success-text fade-in zoom-in-95 duration-300 motion-preset-confetti"><FiCheckCircle aria-hidden={true} />Requirement met</span> : <><QuantityStepper value={quantity} onChange={nextQuantity => {
        setQuantity(nextQuantity);
        setJustMet(false);
      }} /><Button variant="secondary" onClick={handleQuickAdd} className="h-9 cursor-pointer gap-2 whitespace-nowrap px-3 text-caption"><FiPlus aria-hidden={true} /><span>Quick add</span></Button></>;
    $[22] = handleQuickAdd;
    $[23] = quantity;
    $[24] = requirementMet;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t3 || $[28] !== t4 || $[29] !== t9) {
    t11 = <div className={t3}>{t4}{t9}{t10}</div>;
    $[26] = t10;
    $[27] = t3;
    $[28] = t4;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};
interface CatalogItemDetailsDialogProps {
  item: RegularCatalogShopItem | null;
  catalogItems?: ShopItem[];
  cartLines?: ShopCartLine[];
  onConfirm: (item: RegularCatalogShopItem) => void;
  onQuickAddPromotionItem?: (itemId: string, quantity: number) => void;
  onCancel: () => void;
  returnFocusRef?: React.RefObject<HTMLElement | null>;
}
const CatalogItemDetailsDialog: React.FC<CatalogItemDetailsDialogProps> = ({
  item,
  catalogItems = [],
  cartLines = [],
  onConfirm,
  onQuickAddPromotionItem,
  onCancel,
  returnFocusRef
}) => {
  const open = item !== null;
  const lastItemIdRef = useRef<string | null>(null);
  if (item) lastItemIdRef.current = item.id;
  const originalPrice = item ? item.originalPrice ?? item.price : 0;
  const currentPrice = item ? item.displayPrice ?? item.price : 0;
  const promotionDetails = item ? getCatalogPromotionDetails(item, catalogItems) : null;
  const displaySavings = promotionDetails?.displaySavings ?? 0;
  const cartQuantityByItemId = new Map<string, number>();
  for (const line of cartLines) {
    if (!("itemId" in line)) continue;
    cartQuantityByItemId.set(line.itemId, (cartQuantityByItemId.get(line.itemId) ?? 0) + line.quantity);
  }
  return <Dialog open={open} onOpenChange={nextOpen => !nextOpen ? onCancel() : null}>
      <DialogContent className="max-h-[90vh] max-w-2xl gap-0 overflow-hidden p-0" onCloseAutoFocus={event => {
      const returnTarget = returnFocusRef?.current;
      const fallbackTarget = Array.from(document.querySelectorAll<HTMLElement>('[data-shop-placement="category"]')).find(candidate => candidate.dataset.shopItemId === lastItemIdRef.current);
      const focusTarget = returnTarget?.isConnected ? returnTarget : fallbackTarget;
      if (focusTarget) {
        event.preventDefault();
        focusTarget.focus();
      }
    }}>
        {item && promotionDetails && <>
            <div className="min-h-0 flex-1 overflow-y-auto">
              <ShopItemGallery images={shopItemImages(item)} alt={item.name} variant="dialog" />

              <div className="px-6 py-6 md:px-8 md:py-7">
                <header className="grid gap-5 md:grid-cols-[minmax(0,1fr)_auto] md:items-start">
                  <div className="min-w-0">
                    {item.category && <p className="text-micro font-semibold uppercase tracking-[0.2em] text-primary/70">
                        {item.category}
                      </p>}
                    <DialogTitle className="mt-2 text-h1 font-serif font-normal leading-tight text-foreground">
                      {item.name}
                    </DialogTitle>
                    <DialogDescription asChild className="mt-3 max-w-prose text-body leading-relaxed text-foreground-secondary">
                      <div>
                        {item.description ? <ShopItemDescription text={item.description} /> : "Review pricing and offers before adding this item to your cart."}
                      </div>
                    </DialogDescription>
                  </div>

                  <div className="md:min-w-40 md:text-right">
                    <div className="flex flex-wrap items-baseline gap-2 md:justify-end">
                      <p className="font-serif text-[2rem] font-medium leading-none tracking-tight text-foreground tabular-nums md:text-[2.25rem]">
                        <span className="sr-only">Current price: </span>
                        {formatCurrency(currentPrice)}
                      </p>
                      {displaySavings > 0 && <p className="text-caption text-foreground-secondary line-through tabular-nums">
                          <span className="sr-only">Original price: </span>
                          {formatCurrency(originalPrice)}
                        </p>}
                    </div>
                    {displaySavings > 0 && <p className="mt-2 text-body-emphasis text-primary">
                        <span className="sr-only">You </span>
                        save {formatCurrency(displaySavings)} in this preview
                      </p>}
                  </div>
                </header>

                {(promotionDetails.applied.length > 0 || promotionDetails.conditional.length > 0) && <section aria-labelledby="item-promotions-heading" className="mt-7 border-t border-border pt-6">
                    <div className="flex items-center gap-2">
                      <FiTag aria-hidden className="h-4 w-4 text-primary" />
                      <h3 id="item-promotions-heading" className="text-body-emphasis text-foreground">
                        Promotions
                      </h3>
                    </div>

                    {promotionDetails.applied.length > 0 && <ul>
                        {promotionDetails.applied.map(offer => <li key={offer.offerId} className="py-3">
                            <div className="flex items-start gap-3">
                              <FiCheckCircle aria-hidden className="mt-0.5 h-4 w-4 flex-none text-primary" />
                              <div className="min-w-0">
                                <p className="text-body-emphasis text-foreground">
                                  {offer.benefit ?? offer.name}
                                </p>
                                <p className="mt-0.5 text-caption font-medium text-foreground-secondary">
                                  {offer.name}
                                </p>
                                {offer.description && <p className="mt-1 text-caption leading-relaxed text-foreground-secondary">
                                    {offer.description}
                                  </p>}
                                <p className="mt-1 text-caption text-primary">
                                  {offer.isDisplayPriceOffer ? "Included in displayed price" : "Applied automatically at checkout"}
                                </p>
                              </div>
                            </div>
                          </li>)}
                      </ul>}

                    {promotionDetails.conditional.length > 0 && <>
                        <ul>
                          {promotionDetails.conditional.map(offer_0 => <li key={offer_0.offerId} className="py-3">
                              <p className="text-body-emphasis text-foreground">
                                {offer_0.benefit ?? offer_0.name}
                              </p>
                              <p className="mt-0.5 text-caption font-medium text-foreground-secondary">
                                {offer_0.name}
                              </p>
                              {offer_0.description && <p className="mt-1 text-caption leading-relaxed text-foreground-secondary">
                                  {offer_0.description}
                                </p>}
                              {offer_0.requirementGroups.length > 1 && <p className="mt-3 text-caption text-foreground-secondary">
                                  Complete one option in each group:
                                </p>}
                              <ul className="mt-2 space-y-2 text-caption text-primary">
                                {offer_0.requirementGroups.map((group, groupIndex) => <li key={group.group}>
                                      {groupIndex > 0 && <span className="mb-1 block font-semibold text-foreground-secondary">
                                          and
                                        </span>}
                                      {group.alternatives.map((alternative, alternativeIndex) => <React.Fragment key={`${group.group}-${alternativeIndex}`}>
                                            {alternativeIndex > 0 && <span className="block pl-3 font-semibold text-foreground-secondary">
                                                or
                                              </span>}
                                            <span className="block">
                                              {alternative}
                                            </span>
                                          </React.Fragment>)}
                                    </li>)}
                              </ul>
                              {offer_0.relationshipSummary && <p className="mt-3 text-caption font-medium text-foreground">
                                  {offer_0.relationshipSummary}
                                </p>}
                              {onQuickAddPromotionItem && offer_0.actions.length > 0 && <div className="mt-3 space-y-2">
                                    {offer_0.actions.map(action => <PromotionQuickAddRow key={action.itemId} action={action} cartQuantity={cartQuantityByItemId.get(action.itemId) ?? 0} onQuickAdd={onQuickAddPromotionItem} />)}
                                  </div>}
                            </li>)}
                        </ul>
                      </>}

                    {promotionDetails.applied.length > 0 && <p className="mt-4 text-caption leading-relaxed text-foreground-secondary">
                        Final promotions and total are confirmed at checkout.
                      </p>}
                  </section>}

                {item.requiresPickupLocation && <div className="mt-6 flex items-start gap-2 text-caption text-foreground-secondary">
                    <FiMapPin aria-hidden className="mt-0.5 h-4 w-4 flex-none text-primary" />
                    <p>You&apos;ll select a clinic location before payment.</p>
                  </div>}
              </div>
            </div>

            <DialogFooter>
              <Button variant="secondary" onClick={onCancel} className="cursor-pointer">
                <span>Cancel</span>
              </Button>
              <Button variant="primary" onClick={() => onConfirm(item)} className="cursor-pointer">
                <span>Add to cart</span>
              </Button>
            </DialogFooter>
          </>}
      </DialogContent>
    </Dialog>;
};
export default CatalogItemDetailsDialog;